import SEO from "../components/SEO";
import { Reveal, SectionLabel } from "../components/Motion";
import policy from "../lib/privacy-policy.json";
import { BUSINESS_EMAIL } from "../lib/site";

export default function PrivacyPolicy() {
  const updated = new Date(`${policy.lastUpdated}T00:00:00Z`).toLocaleDateString("en-GB", {
    day: "numeric", month: "long", year: "numeric", timeZone: "UTC",
  });

  return (
    <>
      <SEO />
      <div data-testid="privacy-policy-page" className="bg-offwhite pt-40 pb-24 sm:pb-32 min-h-screen">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-10">
          <SectionLabel index="PRIVACY" title="Privacy Policy" />
          <Reveal className="mt-8 max-w-4xl">
            <h1 data-testid="privacy-policy-heading" className="font-display text-5xl sm:text-6xl font-black tracking-tight leading-[0.98]">
              Privacy Policy
            </h1>
            <p data-testid="privacy-policy-company" className="mt-6 text-sm sm:text-base text-charcoal/65 leading-relaxed">
              PT HAQILA GLOBAL TRADING
            </p>
            <p data-testid="privacy-policy-last-updated" className="mt-2 text-sm text-charcoal/60">
              Last updated: <time dateTime={policy.lastUpdated}>{updated}</time>
            </p>
          </Reveal>
          <div className="mt-14 max-w-3xl space-y-10 sm:space-y-12">
            {policy.sections.map((section, index) => (
              <section key={section.id} data-testid={`privacy-section-${section.id}`} aria-labelledby={`privacy-${section.id}`}>
                <h2 id={`privacy-${section.id}`} data-testid={`privacy-heading-${section.id}`} className="font-display text-base sm:text-lg font-bold text-forest">
                  {index + 1}. {section.title}
                </h2>
                <div className="mt-4 space-y-4 text-sm sm:text-base text-charcoal/65 leading-relaxed break-words">
                  {section.paragraphs.map((text, paragraphIndex) => (
                    <p key={paragraphIndex} data-testid={`privacy-copy-${section.id}-${paragraphIndex}`}>{text}</p>
                  ))}
                  {section.links && (
                    <ul className="space-y-2">
                      {section.links.map((link) => (
                        <li key={link.id}>
                          <a href={link.href} target="_blank" rel="noopener noreferrer" data-testid={`privacy-link-${link.id}`}
                            className="text-forest underline underline-offset-4 hover:text-moss transition-colors duration-300">
                            {link.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </section>
            ))}
            <a href={`mailto:${BUSINESS_EMAIL}`} data-testid="privacy-contact-email"
              className="inline-block text-sm font-semibold text-forest underline underline-offset-4 hover:text-moss transition-colors duration-300 break-all">
              {BUSINESS_EMAIL}
            </a>
          </div>
        </div>
      </div>
    </>
  );
}